export default __webpack_public_path__ + "static/media/mdi_web.5662536b.svg";